import styled from "styled-components";

export const SelectWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  flex: 1,
}));

export const SelectContainer = styled("div")(({ theme }) => ({
  position: "relative",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  backgroundColor: "white",
  transition: "all 0.2s ease",
  cursor: `${props => (props.disabled ? "not-allowed" : "pointer")}`,
  boxShadow: `${props => (props.isOpen ? "0 0 0 3px rgba(59, 130, 246, 0.1)" : "none")}`,
  borderColor: `${props => (props.isOpen ? "#3182ce" : "#e2e8f0")}`,

  "&:hover": {
    borderColor: `${props => (props.disabled ? "#e2e8f0" : "#cbd5e0")}`,
  },
}));

export const IconContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  left: 16,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 20,
  color: "#718096",
  zIndex: 2,
}));

export const Input = styled("input")(({ theme }) => ({
  width: "100%",
  padding: "16px 52px 16px 52px",
  border: "none",
  borderRadius: 12,
  fontSize: 16,
  backgroundColor: "transparent",
  outline: "none",
  color: "#2d3748",
  fontWeight: 400,

  "&::placeholder": {
    color: "#a0aec0",
  },

  "&:disabled": {
    cursor: "not - allowed",
    backgroundColor: "#f7fafc",
  },
}));

export const DropdownArrow = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: `translateY(-50%) rotate(${props => (props.isOpen ? "180deg" : "0deg")})`,
  color: "#718096",
  transition: "transform 0.2s ease",
  cursor: `${props => (props.disabled ? "not-allowed" : "pointer")}`,
  zIndex: 2,

  "&::before": {
    content: "▼",
    fontSize: 12,
  },
}));

export const Dropdown = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "calc(100% + 4px)",
  left: 0,
  right: 0,
  backgroundColor: "white",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  maxHeight: 240,
  overflowY: "auto",
  zIndex: 1000,
  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
}));

export const DropdownOption = styled("div")(({ theme }) => ({
  padding: "14px 16px",
  cursor: "pointer",
  borderBottom: "1px solid #f1f5f9",
  display: "flex",
  alignItems: "center",
  gap: 12,
  backgroundColor: `${props => (props.isSelected ? "#f8fafc" : "white")}`,
  transition: "background-color 0.15s ease",

  "&:hover": {
    backgroundColor: "#f1f5f9",
  },

  "&:last-child": {
    borderBottom: "none",
  },
}));

export const Flag = styled("span")(({ theme }) => ({
  fontSize: 18,
  minWidth: 24,
}));

export const CountryName = styled("span")(({ theme }) => ({
  fontSize: 15,
  color: "#2d3748",
}));

export const NoResults = styled("div")(({ theme }) => ({
  padding: 16,
  color: "#718096",
  fontStyle: "italic",
  textAlign: "center",
  fontSize: 14,
}));

export const DefaultBadge = styled("span")(({ theme }) => ({
  marginLeft: "auto",
  fontSize: 14,
}));

export const SectionHeader = styled("div")(({ theme }) => ({
  padding: "12px 16px 8px",
  fontSize: 13,
  fontWeight: 500,
  color: "#9ca3af",
  letterSpacing: 0.5,
}));

export const CheckIcon = styled("div")(({ theme }) => ({
  color: "#10a37f",
  fontSize: 20,
  fontWeight: "bold",
  marginLeft: "auto",
}));
